// extracted by mini-css-extract-plugin
export default {"timeProfileCard":"styles_timeProfileCard__Mdf3N","details":"styles_details__SPJQm","icon":"styles_icon__yiiKR","img":"styles_img__1syGF"};